import React from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import ChatFooter from '../../footers/Chat';
import ChatInput from '../../../molecules/ChatInput';
import {theme} from '../../../../styles/darkTheme';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../redux/reducers';
import {sendMessage} from '../../../../redux/actions/channel';
import {useTranslation} from '../../../../context/language';

interface Values {
  text: string;
}

const defaultValues: Values = {
  text: '',
};

interface Props {
  reply: string;
  setReply: (value: any) => void;
}

const ChatForm: React.FC<Props> = ({reply, setReply}) => {
  const {text: t} = useTranslation();
  const validationSchema = Yup.object().shape({
    text: Yup.string().trim().required(),
  });

  const {currentChannel} = useSelector((state: RootState) => ({
    ...state.channel,
  }));
  const dispatch = useDispatch();

  return (
    <Formik
      validateOnMount
      initialValues={defaultValues}
      onSubmit={({text}, {setSubmitting, resetForm, setFieldValue}) => {
        if (currentChannel) {
          dispatch(
            sendMessage(currentChannel, text, undefined, undefined, reply),
          );
        }
        if (reply) setReply(null);
        setFieldValue('text', '');
        resetForm();
      }}
      validationSchema={validationSchema}>
      {({values: {text}, handleChange, isValid, handleSubmit}) => (
        <ChatFooter>
          <ChatInput
            type="text"
            theme={theme}
            placeholder={t.writeSomething}
            value={text}
            onChange={handleChange('text')}
            onSend={handleSubmit}
            buttonDisabled={!isValid}
          />
        </ChatFooter>
      )}
    </Formik>
  );
};

export default ChatForm;
